
import {USER_DATA_CONSTANT} from '../_constants/Redux/userData.constant'

export const UserDataActions = {
    addCompare,
    removeCompare,
    clearCompare,
    addCompareParameter,
    addCartCount,
    removeCartCount,
    clearCartCount,
    userFilledDataChache
}

function addCompare(data){
    return {type:USER_DATA_CONSTANT.ADD_COMPARE,data}
}

function removeCompare(data){
    return {type:USER_DATA_CONSTANT.REMOVE_COMPARE,data}
}

function clearCompare() {
    return {type:USER_DATA_CONSTANT.CLEAR_COMPARE}
}

function addCompareParameter(data) {
    return {type:USER_DATA_CONSTANT.ADD_COMPARE_PARAMETER,data}
}

function addCartCount(data) {
    return {type:USER_DATA_CONSTANT.ADD_CART_COUNT,data}
}

function removeCartCount(data) {
    return {type:USER_DATA_CONSTANT.MINUS_CART_COUNT,data}
}

function clearCartCount() {
    return {type:USER_DATA_CONSTANT.CLEAR_CART_COUNT}
}

function userFilledDataChache(data) {
    return {type:USER_DATA_CONSTANT.ADD_DATA_CACHE,data}
}